import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export function SearchTitleV2(props = {}, childrenComponents) {
	return {
		componentName: 'SearchTitleV2',
		componentId: uuidv4(),
		props: _.merge(
			{
				mzSearchDummyTitle: 'camisa',
			},
			props,
		),
		childrenComponents,
	};
}
